import { createMetaMixin } from 'quasar'

/**
 * Meta mixin that reads pageTitle and pageDescription from component computed properties
 * with automatic fallback to currentSite values when available
 * Usage: Add 'metaMixin' to your mixins array and define computed properties:
 * - pageTitle: string - The page title (falls back to currentSite.displayName if available)
 * - pageDescription: string (optional) - The page description (falls back to currentSite.siteDescription if available)
 */
export const metaMixin = createMetaMixin(function () {
  const meta = {}

  const finalDescription = this.pageDescription || this.currentSite?.siteDescription
  if (finalDescription) {
    meta.description = { name: 'description', content: finalDescription }
  }

  return {
    title: this.pageTitle || this.currentSite?.displayName,
    meta
  }
})
